import { Link, useNavigate, useSearchParams } from "react-router-dom";
import moment from "moment";
import Header from "../../components/partials/Header";
import Footer from "../../components/partials/Footer";
import CatalogItem from "../../components/CatalogItem";
import CatalogItemDesc from "../../components/CatalogItemDesc";



const Catalog = () => {
    const navigate = useNavigate(); // Initialize the navigate function

    const images = {
        iso: '/images/iso.png',
        size: '/images/c_size.png',
        weight: '/images/c_weight.png',
        kg: '/images/c_kg.png',
        fix: '/images/c_fix.png',
        tires: '/images/c_tires.png',
        stairs: '/images/c_stairs.png',
        spaces: '/images/c_spaces.png',
        layers: '/images/c_layers.png',
        orange: '/images/orange.png',
    }

    const Block = ({ image, title }) => {
        return (
            <p>
                <img src={image} alt="" />
                {title}
            </p>
        )
    }

    return (
        <>
            <div id="hero" className="inner_page" style={{ backgroundImage: "url('/images/hero_inner.png')" }}>
                <Header page={'catalog'} />

                <div className="inner_page_title">
                    <h1>კატალოგი</h1>
                </div>
            </div>
            
            <div className="catalog_wrapper">
                <CatalogItem 
                    title={'SKY 001'}
                    subtitle={'შიდა სამუშაო ხარაჩო'}
                    image={'/images/catalog/SKY 001.png'}
                    desc={<CatalogItemDesc>
                        <p>SKY-001 წარმოადგენს მაღალი ხარისხის შიდა სამუშაო ხარაჩოს, რომელიც იდეალურია შენობის შიდა სამუშაოებისთვის.
                        მისი კომპაქტური და ერგონომიული დიზაინი საშუალებას გაძლევთ ეფექტურად იმუშაოთ შეზღუდულ სივრცეებში.</p>

                        <div className="cid_blocks">
                            <div className="cid_block tech_stats">
                                <h4>ტექნიკური მახასიათებლები</h4>
                                <Block image={images.size} title={'ზომები: 800x2000x2000მმ'} />
                                <Block image={images.weight} title={'მსუბუქი წონა'} />
                                <Block image={images.fix} title={'მარტივი და სწრაფი მონტაჟი'} />
                                <Block image={images.kg} title={'დატვირთვა; 1 მ2 225-კგ'} />
                            </div>
                            <div className="cid_block iso_stats">
                                <h4>ტექნიკური მახასიათებლები</h4>
                                <span>სერტიფიცირებულია ადგილობრივი და საერთაშორისო სტანდარტების შესაბამისად</span>
                                <Block image={images.iso} title={'ISO 9001:2015'} />
                                <Block image={images.iso} title={'BS EN 39:2001'} />
                                <Block image={images.iso} title={'EN 12810-1:2003'} />
                                
                            </div>
                        </div>
                    </CatalogItemDesc>}
                />

                <CatalogItem 
                    title={'SKY 200'}
                    subtitle={'შიდა სამუშაო ბორბლებიანი ხარაჩო'}
                    image={'/images/catalog/SKY 200.png'}
                    desc={<CatalogItemDesc>
                        <p>SKY-200 შიდა სამუშაო ხარაჩო მოძრავი ბაზით, კონსტრუქცია აღჭურვილია მაღალი გამძლეობის მქონე ბორბლებითა და რეგულირებადი საყრდენი სისტემით, რაც უზრუნველყოფს როგორც მარტივ გადაადგილებას, ასევე მაქსიმალურ სიმყარეს მუშაობის პროცესში.</p>

                        <div className="cid_blocks">
                            <div className="cid_block tech_stats">
                                <h4>ტექნიკური მახასიათებლები</h4>
                                <Block image={images.size} title={'ზომები:  800x2000x3000მმ'} />
                                <Block image={images.weight} title={'მსუბუქი წონა'} />
                                <Block image={images.fix} title={'მარტივი და სწრაფი მონტაჟი'} />
                                <Block image={images.kg} title={'დატვირთვა; 1 მ2,  225-კგ'} />
                            </div>
                            <div className="cid_block iso_stats">
                                <h4>ტექნიკური მახასიათებლები</h4>
                                <span>სერტიფიცირებულია ადგილობრივი და საერთაშორისო სტანდარტების შესაბამისად</span>
                                <Block image={images.iso} title={'ISO 9001:2015'} />
                                <Block image={images.iso} title={'BS EN 39:2001'} />
                                <Block image={images.iso} title={'EN 12810-1:2003'} />
                                
                            </div>
                        </div>
                    </CatalogItemDesc>}
                />

                <CatalogItem 
                    title={'SKY 400'}
                    subtitle={'შიდა სამუშაო ბორბლებიანი ხარაჩო'}
                    image={'/images/catalog/SKY 400.png'}
                    desc={<CatalogItemDesc>
                        <p>შიდა სამუშაო ბორბლებიანი ხარაჩო - SKY 400, გამოიყენება სხვადასხვა ტიპის შენობის შიდა სამონტაჟო, სარემონტო და მოსაპირკეთებელი სამუშაოების დროს.</p>

                        <div className="cid_blocks">
                            <div className="cid_block tech_stats">
                                <h4>ტექნიკური მახასიათებლები</h4>
                                <Block image={images.size} title={'ზომები:  1300x2000x4000მმ'} />
                                <Block image={images.weight} title={'მსუბუქი წონა'} />
                                <Block image={images.fix} title={'მარტივი და სწრაფი მონტაჟი'} />
                                <Block image={images.kg} title={'დატვირთვა; 1 მ2,  225-კგ'} />
                            </div>
                            <div className="cid_block iso_stats">
                                <h4>ტექნიკური მახასიათებლები</h4>
                                <span>სერტიფიცირებულია ადგილობრივი და საერთაშორისო სტანდარტების შესაბამისად</span>
                                <Block image={images.iso} title={'ISO 9001:2015'} />
                                <Block image={images.iso} title={'BS EN 39:2001'} />
                                <Block image={images.iso} title={'EN 12810-1:2003'} />
                                
                            </div>
                        </div>
                    </CatalogItemDesc>}
                />

                
                <CatalogItem 
                    title={'SKY 600'}
                    subtitle={'შიდა სამუშაო ბორბლებიანი ხარაჩო'}
                    image={'/images/catalog/SKY 600.png'}
                    desc={<CatalogItemDesc>
                        <p>შიდა სამუშაო ბორბლებიანი ხარაჩო - SKY 600,  კონსტრუქციის უნივერსალური დიზაინის საშუალებით შესაძლებელია, მაღალი ხარისხით, ეფექტურად შესრულდეს, როგორც სამონტაჟო და სარემონტო, ისე მოსაპირკეთებელი სამუშაოები.</p>

                        <div className="cid_blocks">
                            <div className="cid_block tech_stats">
                                <h4>ტექნიკური მახასიათებლები</h4>
                                <Block image={images.size} title={'ზომები:  1250*4000*6000მმ'} />
                                <Block image={images.weight} title={'მსუბუქი წონა'} />
                                <Block image={images.fix} title={'მარტივი და სწრაფი მონტაჟი'} />
                                <Block image={images.kg} title={'დატვირთვა; 1 მ2,  225-კგ'} />
                            </div>
                            <div className="cid_block iso_stats">
                                <h4>ტექნიკური მახასიათებლები</h4>
                                <span>სერტიფიცირებულია ადგილობრივი და საერთაშორისო სტანდარტების შესაბამისად</span>
                                <Block image={images.iso} title={'ISO 9001:2015'} />
                                <Block image={images.iso} title={'BS EN 39:2001'} />
                                <Block image={images.iso} title={'EN 12810-1:2003'} />
                                
                            </div>
                        </div>
                    </CatalogItemDesc>}
                />

                

                
                <CatalogItem 
                    title={'SKY M1'}
                    subtitle={'სიმაღლეზე სამუშაო მოძრავი კიბე -  SKY M1'}
                    image={'/images/catalog/SKY M1.png'}
                    desc={<CatalogItemDesc>
                        <p>შიდა სამუშაო ბორბლებიანი ხარაჩო - SKY 600,  კონსტრუქციის უნივერსალური დიზაინის საშუალებით შესაძლებელია, მაღალი ხარისხით, ეფექტურად შესრულდეს, როგორც სამონტაჟო და სარემონტო, ისე მოსაპირკეთებელი სამუშაოები.</p>

                        <div className="cid_blocks">
                            <div className="cid_block tech_stats">
                                <h4>ტექნიკური მახასიათებლები</h4>
                                <Block image={images.stairs} title={'ერგონომიული საფეხურები უსაფრთხო ასვლისთვის'} />
                                <Block image={images.layers} title={'მყარი სამუშაო პლატფორმა'} />
                                <Block image={images.tires} title={'მობილური ბორბლები მარტივი გადაადგილებისთვის'} />
                                <Block image={images.spaces} title={'კომპაქტური დიზაინი შეზღუდული სივრცეებისთვის'} />
                            </div>
                            <div className="cid_block iso_stats">
                                <h4>ტექნიკური მახასიათებლები</h4>
                                <span>სერტიფიცირებულია ადგილობრივი და საერთაშორისო სტანდარტების შესაბამისად</span>
                                <Block image={images.iso} title={'ISO 9001:2015'} />
                                <Block image={images.iso} title={'BS EN 39:2001'} />
                                <Block image={images.iso} title={'EN 12810-1:2003'} />
                                
                            </div>
                        </div>
                    </CatalogItemDesc>}
                />


                <CatalogItem 
                    title={'SKY FACADE'}
                    subtitle={'ფასადის ხარაჩო'}
                    image={'/images/catalog/SKU FACADE.png'}
                    desc={<CatalogItemDesc>
                        <p>ფასადის ხარაჩო - SKY Facade, დამზადებულია უმაღლესი ხარისხის სერტიფიცირებული ნედლეულისგან ქარხნული წესით.</p>

                        <div className="cid_blocks">
                            <div className="cid_block tech_stats">
                                <h4>ტექნიკური მახასიათებლები</h4>
                                <Block image={images.orange} title={'მარტივად ასაწყობი'} />
                                <Block image={images.orange} title={'ხარისხიანი შედუღების ნაკერები'} />
                                <Block image={images.orange} title={'მაღალი დატვირთვის გაძლების უნარი'} />
                                <Block image={images.orange} title={'დატვირთვა 1მ2 225კგ'} />
                            </div>
                            <div className="cid_block iso_stats">
                                <h4>ტექნიკური მახასიათებლები</h4>
                                <span>სერტიფიცირებულია ადგილობრივი და საერთაშორისო სტანდარტების შესაბამისად</span>
                                <Block image={images.iso} title={'ISO 9001:2015'} />
                                <Block image={images.iso} title={'BS EN 39:2001'} />
                                <Block image={images.iso} title={'EN 12810-1:2003'} />
                                
                            </div>
                        </div>
                    </CatalogItemDesc>}
                />
                


                <CatalogItem 
                    title={'ორმაგი ხამუთებით ხარაჩო'}
                    subtitle={''}
                    image={'/images/catalog/ორმაგი ხამუთებით.png'}
                    desc={<CatalogItemDesc>
                        <p>ორმაგი ხამუთებით ასაწყობი ხარაჩო პროექტდება თითოეული სამშენებლო ობიექტის უნიკალური მოთხოვნების გათვალისწინებით. სისტემა ეწყობა საერთაშორისო სტანდარტების სრული დაცვით, მაღალი კვალიფიკაციისა და პრაქტიკული გამოცდილების მქონე ტექნიკური პერსონალის მიერ, რაც უზრუნველყოფს კონსტრუქციის მაქსიმალურ საიმედოობასა და უსაფრთხოებას ექსპლუატაციის მთელი პერიოდის განმავლობაში.</p>

                        <div className="cid_blocks">
                            <div className="cid_block iso_stats">
                                <h4>უსაფრთხოების სტანდარტები</h4>
                                <span>სერტიფიცირებულია ადგილობრივი და საერთაშორისო სტანდარტების შესაბამისად</span>
                            </div>
                            <div className="cid_block iso_stats">
                                <Block image={images.iso} title={'N-677.27.10.2017'} />
                                <Block image={images.iso} title={'ISO 9001:2015'} />
                                <Block image={images.iso} title={'BS EN 39:2001'} />
                                <Block image={images.iso} title={'EN 12810-1:2003'} />
                                
                            </div>
                        </div>
                    </CatalogItemDesc>}
                />


                <CatalogItem 
                    title={'შიდა სამუშაო ხარაჩო აივნებით'}
                    subtitle={''}
                    image={'/images/catalog/შიდა სამუშაოების.png'}
                    desc={<CatalogItemDesc>
                        <p>შიდა სამუშაო ხარაჩო დამატებითი გარე გასასვლელი აივნებით პროექტდებაა თითოეული შენობის უნიკალური არქიტექტურული და კონსტრუქციული მოთხოვნების გათვალისწინებით. <br /><br />

მონტაჟი ხორციელდება საერთაშორისო სტანდარტებთან შესაბამისობით, მაღალი კვალიფიკაციისა და პრაქტიკული გამოცდილების მქონე ტექნიკური პერსონალის მიერ. </p>

                        <div className="cid_blocks">
                            <div className="cid_block iso_stats">
                                <h4>უსაფრთხოების სტანდარტები</h4>
                                <span>სერტიფიცირებულია ადგილობრივი და საერთაშორისო სტანდარტების შესაბამისად</span>
                            </div>
                            <div className="cid_block iso_stats">
                                <Block image={images.iso} title={'N-677.27.10.2017'} />
                                <Block image={images.iso} title={'ISO 9001:2015'} />
                                <Block image={images.iso} title={'BS EN 39:2001'} />
                                <Block image={images.iso} title={'EN 12810-1:2003'} />
                                
                            </div>
                        </div>
                    </CatalogItemDesc>}
                />

                <CatalogItem 
                    title={'უსაფრთხოების მოაჯირი'}
                    subtitle={''}
                    image={'/images/catalog/უსაფრთხოების მოაჯირი.png'}
                    desc={<CatalogItemDesc>
                        <p>უსაფრთხოების მოაჯირი - ფიქსირებული უსაფრთხოების მოაჯირი შექმნილია სამუშაო ზონის პერიმეტრის დაცვისთვის და უზრუნველყოფს პერსონალის მაქსიმალურ უსაფრთხოებას სიმაღლეზე მუშაობისას. <br /><br />

მონტაჟი ხორციელდება საერთაშორისო სტანდარტებთან შესაბამისობით, მაღალი კვალიფიკაციისა და პრაქტიკული გამოცდილების მქონე ტექნიკური პერსონალის მიერ.</p>

                        <div className="cid_blocks">
                            <div className="cid_block iso_stats">
                                <h4>უსაფრთხოების სტანდარტები</h4>
                                <Block image={images.iso} title={'უსაფრთხოების მოაჯირის აწყობა ხორციელდება N477 '} />
                                <Block image={images.iso} title={'უსაფრთხოების მოაჯირის აწყობა ხორციელდება N477 27.10.2017 დადგენილების შესაბამისად'} />
                            </div>
                        </div>
                    </CatalogItemDesc>}
                />

                <CatalogItem 
                    title={'საყალიბე სისტემა'}
                    subtitle={''}
                    image={'/images/catalog/საყალიბე 1.png'}
                    desc={<CatalogItemDesc>
                        <p>საყალიბე სისტემა საყალიბე სისტემები წარმოადგენს თანამედროვე სამშენებლო ტექნოლოგიების ინოვაციურ გადაწყვეტას, რომელიც მნიშვნელოვნად ზრდის სამუშაო პროცესის ეფექტურობას და პერსონალის პროდუქტიულობას.
სისტემის უნიკალური დიზაინი უზრუნველყოფს მონტაჟის, დემონტაჟისა და ტრანსპორტირების მაქსიმალურ სიმარტივეს, რაც მინიმუმამდე ამცირებს სამუშაო დროს. <br /><br />

წარმოების პროცესში გამოიყენება მხოლოდ პრემიუმ ხარისხის, საერთაშორისო სტანდარტების შესაბამისი მასალები, ხოლო პროდუქციის დამზადება ხორციელდება მაღალკვალიფიციური სპეციალისტების მიერ.</p>

                            <div className="cid_blocks">
                                <div className="cid_block iso_stats">
                                <h4>უსაფრთხოების სტანდარტები</h4>
                                <span>სერტიფიცირებულია ადგილობრივი და საერთაშორისო სტანდარტების შესაბამისად</span>
                            </div>
                            <div className="cid_block iso_stats">
                                <Block image={images.iso} title={'N-677.27.10.2017'} />
                                <Block image={images.iso} title={'ISO 9001:2015'} />
                                <Block image={images.iso} title={'BS EN 39:2001'} />
                                <Block image={images.iso} title={'EN 12810-1:2003'} />
                                
                            </div>
                        </div>
                    </CatalogItemDesc>}
                />


                <CatalogItem 
                    title={'HOOK CM911'}
                    subtitle={'ფასადის ხარაჩო'}
                    image={'/images/catalog/HOOK CM911.png'}
                    desc={<CatalogItemDesc>
                        <p>აივანი დიაფრაგმაზე სამონტაჟო სამუშაოებისთვის - HOOK CM911  წარმოადგენს პროფესიონალურ სამონტაჟო პლატფორმას, რომელიც სპეციალურად შექმნილია დიაფრაგმებზე სამუშაოებისთვის. <br /> <br />

წარმოების პროცესში გამოიყენება მხოლოდ პრემიუმ ხარისხის, საერთაშორისო სტანდარტების შესაბამისი მასალები, ხოლო პროდუქციის დამზადება ხორციელდება მაღალკვალიფიციური სპეციალისტების მიერ.</p>

                            <div className="cid_blocks">
                                <div className="cid_block iso_stats">
                                <h4>უსაფრთხოების სტანდარტები</h4>
                                <span>სერტიფიცირებულია ადგილობრივი და საერთაშორისო სტანდარტების შესაბამისად</span>
                            </div>
                            <div className="cid_block iso_stats">
                                <Block image={images.iso} title={'N-677.27.10.2017'} />
                                <Block image={images.iso} title={'ISO 9001:2015'} />
                                <Block image={images.iso} title={'BS EN 39:2001'} />
                                <Block image={images.iso} title={'EN 12810-1:2003'} />
                                
                            </div>
                        </div>
                    </CatalogItemDesc>}
                />

                <CatalogItem 
                    title={'SKY-MS7'}
                    subtitle={''}
                    image={'/images/catalog/SKY MS7.png'}
                    desc={<CatalogItemDesc>
                        <p>ტვირთის მიმღები ბაქანი - SKY MS7,  წარმოადგენს სპეციალიზებულ ტვირთის მიმღებ პლატფორმას, რომელიც შექმნილია სამშენებლო სამუშაოების დროს მძიმე ტვირთების უსაფრთხო მიღებისა და განთავსებისთვის.</p>

                            <div className="cid_blocks">
                                <div className="cid_block tech_stats">
                                    <h4>ტექნიკური მახასიათებლები</h4>

                                    <Block image={images.orange} title={'დატვირთვა: 2 ტონა'} />
                                    <Block image={images.orange} title={'მყარი კონსტრუქცია გაძლიერებული საყრდენებით'} />

                            </div>
                            <div className="cid_block iso_stats">
                                <h4>უსაფრთხოების სტანდარტები</h4>
                                <span>სერტიფიცირებულია ადგილობრივი და საერთაშორისო სტანდარტების შესაბამისად</span>
                                <Block image={images.iso} title={'N-477.27.10.2017'} />
                                <Block image={images.iso} title={'N-361.27.05.2014'} />
                                <Block image={images.iso} title={'ISO 9001:2015'} />
                                
                            </div>
                        </div>
                    </CatalogItemDesc>}
                />


                <CatalogItem 
                    title={'ტელესკოპური ხარაჩო'}
                    subtitle={''}
                    image={'/images/catalog/ტელესკოპური ხარაჩო.png'}
                    desc={<CatalogItemDesc>
                        <p>ტელესკოპური ხარაჩო გამოირჩევა რეგულირებადი (გახსნადი-დაკეცვადი) კონსტრუქციით.
                        გამოიყენება ძირითადად შიდა და გარე სამშენებლო, სარემონტო და მოსაპირკეთებელ სამუშაოებში, სადაც საჭიროა სიმაღლის მარტივი და სწრაფი რეგულირება.</p>

                            <div className="cid_blocks">
                                <div className="cid_block tech_stats">
                                    <h4>ტექნიკური მახასიათებლები</h4>

                                    <Block image={images.orange} title={'სტანდარტული მოდელები 2-დან 12 მეტრამდე'} />
                                    <Block image={images.orange} title={'მარტივი და სწრაფი მონტაჟი'} />
                                    <Block image={images.orange} title={'დატვირთვის სიმძლავრე: საშუალოდ 150-300 კგ/მ²'} />
                                    <Block image={images.orange} title={'მარტივი გადასაადგილებელი'} />

                            </div>
                            <div className="cid_block iso_stats">
                                <h4>უსაფრთხოების სტანდარტები</h4>
                                <span>სერტიფიცირებულია ადგილობრივი და საერთაშორისო სტანდარტების შესაბამისად</span>
                                <Block image={images.iso} title={'N-477.27.10.2017'} />
                                <Block image={images.iso} title={'N-361.27.05.2014'} />
                                <Block image={images.iso} title={'ISO 9001:2015'} />
                                
                            </div>
                        </div>
                    </CatalogItemDesc>}
                />



                <CatalogItem 
                    title={'ლაზერული ჭრა'}
                    subtitle={''}
                    image={'/images/catalog/ლაზერული.png'}
                    desc={<CatalogItemDesc>
                        <p>Sky Hook-ი გთავაზობთ ლაზერული ჭრის პროფესიონალურ სერვისს.
აპარატის ციფრული მართვის სისტემით შესაძლებელია რთული დეტალებისა და კომპლექსური ფორმების ჭრა.
</p>

                            <div className="cid_blocks">
                                <div className="cid_block tech_stats">
                                    <h4>ტექნიკური მახასიათებლები</h4>

                                    <Block image={images.orange} title={'სწრაფი შესრულების დრო'} />
                                    <Block image={images.orange} title={'მარტივი და სწრაფი მონტაჟი'} />
                                    <Block image={images.orange} title={'დატვირთვის სიმძლავრე: საშუალოდ 150-300 კგ/მ²'} />
                                    <Block image={images.orange} title={'მარტივი გადასაადგილებელი'} />

                            </div>
                        </div>
                    </CatalogItemDesc>}
                />



                <CatalogItem 
                    title={'ლითონის მოხრა (მოღუნვა)'}
                    subtitle={''}
                    image={'/images/catalog/ლითონის მოხრა.png'}
                    desc={<CatalogItemDesc>
                        <p>ლითონის მოხრა (მოღუნვა) სერვისი - გთავაზობთ ლითონის მასალების ტრანსფორმაციას კონკრეტული პროექტის მოთხოვნების შესაბამისად. 
                        სხვადასხვა სახის ლითონის პროფილების ზუსტი დამუშავება პროექტის საჭიროებისამებრ. სერვისი იდეალურია როგორც სტანდარტული, ისე არასტანდარტული პროექტებისთვის, სადაც საჭიროა სპეციფიკური მრუდის ფორმები, წრიული კონსტრუქციები, თაღები ან დეკორატიული ელემენტები. </p>

                    </CatalogItemDesc>}
                />




                <CatalogItem 
                    title={'სამშენებლო დგარი'}
                    subtitle={''}
                    image={'/images/catalog/სამშენებლო დგარი.png'}
                    desc={<CatalogItemDesc>
                        <p>სამშენებლო დგარი დროებითი კონსტრუქციაა, რომელიც გამოიყენება ჭერის, იატაკის, ბეტონის ფილების ან სხვა სამშენებლო ელემენტების მხარდასაჭერად, სანამ ისინი ბოლომდე გამაგრდება და დამაგრდება. <br /> <br />

გამოიყენება როგორც მცირე, ისე მასშტაბური სამშენებლო პროექტებისთვის. </p>

                            <div className="cid_blocks">
                                <div className="cid_block tech_stats">
                                    <h4>ტექნიკური მახასიათებლები</h4>

                                    <Block image={images.orange} title={'მტკიცე კონსტრუქცია(ფოლადი, ალუმინი)'} />
                                    <Block image={images.orange} title={'რეგულირებადი სიმაღლე'} />
                            </div>
                            <div className="cid_block iso_stats">
                                <h4>უსაფრთხოების სტანდარტები</h4>
                                <span>სერტიფიცირებულია ადგილობრივი და საერთაშორისო სტანდარტების შესაბამისად</span>
                            </div>
                        </div>
                    </CatalogItemDesc>}
                />


                <CatalogItem 
                    title={'ხარაჩოს მონტაჟისა და დემონტაჟის სერვისი'}
                    subtitle={''}
                    image={'/images/catalog/ხარაჩოს მონტაჟი.png'}
                    desc={<CatalogItemDesc>
                        <p> ხარაჩოს მონტაჟისა და დემონტაჟის სერვისი გთავაზობთ ხარაჩოების მონტაჟისა და დემონტაჟის პროფესიონალურ   მომსახურებას. <br /> <br />

ჩვენი გამოცდილი გუნდი უზრუნველყოფს უსაფრთხო, ეფექტურ და დროულ  სამუშაოს შესრულებას. მონტაჟის პროცესი იწყება დეტალური დაგეგმვით, სადაც  გათვალისწინებულია ყველა უსაფრთხოების ასპექტი და ობიექტის  თავისებურება.
ვიყენებთ მხოლოდ სერტიფიცირებულ, მაღალი ხარისხის კომპონენტებს, რაც  უზრუნველყოფს კონსტრუქციის სტაბილურობას და საიმედოობას. დემონტაჟის პროცესი არანაკლებ მნიშვნელოვანია უსაფრთხოების  თვალსაზრისით, ამიტომ ამ ეტაპსაც ვანიჭებთ განსაკუთრებულ ყურადღებას. სერვისი მოიცავს ყველა ტიპის ხარაჩოს მონტაჟს - ფასადის, მოძრავ,  კონსოლურ თუ სპეციალური კონფიგურაციის ხარაჩოებს ნებისმიერი  სირთულის არქიტექტურული ობიექტებისთვის</p>

                    </CatalogItemDesc>}
                />






                <CatalogItem 
                    title={'შრომის უსაფრთხოების სერვისი'}
                    subtitle={''}
                    image={'/images/catalog/უსაფრთხოების სერვისი.png'}
                    desc={<CatalogItemDesc>
                        <p><b>SkyHook გთავაზობთ კომპლექსურ შრომის უსაფრთხოების მომსახურებას,</b>  რომელიც მორგებულია თქვენი კომპანიის სპეციფიკაზე.</p>

                        <p><b>ჩვენი გუნდი  უზრუნველყოფს:</b></p>
                        <div className="dd_blocks">
                            <Block image={images.orange} title={'რისკების შეფასებას'} />
                            <Block image={images.orange} title={'უსაფრთხოების დოკუმენტაციის  შემუშავებას,'} />
                            <Block image={images.orange} title={'თანამშრომელთა ტრენინგებს'} />
                            <Block image={images.orange} title={'საგანგებო სიტუაციების მართვის  გეგმების შექმნას'} />
                            <Block image={images.orange} title={'რეგულარულ მონიტორინგს'} />
                        </div>
                        <p><b>მოგვანდეთ თქვენი  შრომის უსაფრთხოების მართვა და შექმენით უსაფრთხო,  კანონმდებლობასთან შესაბამისი სამუშაო გარემო.</b></p>

                    </CatalogItemDesc>}
                />





            </div>

            <Footer />

        </>
    )
}
  
export default Catalog